import { useGate, useStore, useStoreMap } from 'effector-react'
import { useState } from 'react'
import {
  Gate,
  $rentalServices,
  getRentalServicesFx,
} from '~/entities/RentalService/model'
import { RentalService } from '~/shared/api'
import { AccordionGroup } from '~/shared/ui/AccordionGroup'
import { Checkbox } from '~/shared/ui/form'
import { Skeleton } from '~/shared/ui/SkeletonList'
import { More } from '../More'
import { Content, IonAccordion, IonItem } from './styled'

export function RentalServiceAccordion() {
  useGate(Gate)

  const rentalServicesPending = useStore(getRentalServicesFx.pending)
  const rentalServices = useStoreMap($rentalServices, (rentalServices) =>
    (rentalServices || []).map((rentalService: RentalService) => ({
      id: rentalService.getApiId() as UniqueId,
      ...rentalService.getAttributes(),
    })),
  )

  const [accordionKeys, setAccordionKeys] = useState<string[]>([
    'rentalServices',
  ])

  const handleAccordionChange = (keys: 'on' | string[]) => {
    if (keys === 'on') return
    setAccordionKeys(keys)
  }

  if (rentalServicesPending)
    return <Skeleton animated $height={24} style={{ margin: 0 }} />

  if (!rentalServicesPending && !rentalServices?.length) return

  return (
    <AccordionGroup
      defaultValue={accordionKeys}
      onChange={handleAccordionChange}
    >
      <IonAccordion value='rentalServices' disabled={rentalServicesPending}>
        <IonItem slot='header'>Дополнительные услуги</IonItem>

        <Content slot='content'>
          {rentalServices.map((rentalService) => (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                justifyContent: 'space-between',
              }}
              key={rentalService.id}
            >
              <Checkbox
                name={`rentalServices.${rentalService.id}`}
                label={rentalService.name}
                mode='md'
              />
              <More />
            </div>
          ))}
        </Content>
      </IonAccordion>
    </AccordionGroup>
  )
}
